import Popup from "../../../../../../common/components/popup";
import SettlementsItems from "./settlement-items";

export const SettlementItemsPopup = ({ 
  selectedSettlement,
  closeModal,
  
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementsItems
            selectedSettlement={selectedSettlement}
          />
        </Popup>
      </>
    )
  }